import * as React from 'react';

const SectionLeftSvg = (props: React.SVGProps<SVGSVGElement>) => (
    <svg
        id="section-left_svg__eds-icon--section-left_svg"
        x={0}
        y={0}
        viewBox="0 0 24 24"
        xmlSpace="preserve"
        {...props}
    >
        <path
            id="section-left_svg__eds-icon--section-left_base"
            fillRule="evenodd"
            clipRule="evenodd"
            fill="#010101"
            d="M5 17h6v2H5v-2zm-1 3h8v-4H4v4z"
        />
        <path
            id="section-left_svg__eds-icon--section-left_middle"
            fillRule="evenodd"
            clipRule="evenodd"
            fill="#010101"
            d="M4 10v4h16v-4H4zm15 3H5v-2h14v2z"
        />
        <path
            id="section-left_svg__eds-icon--section-left_top_1_"
            fillRule="evenodd"
            clipRule="evenodd"
            fill="#010101"
            d="M4 4v4h16V4H4zm15 3H5V5h14v2z"
        />
    </svg>
);

SectionLeftSvg.displayName = 'SectionLeftSvg';
export default SectionLeftSvg;
